var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.route,"event":!item.disabled ? 'click' : ''}},[_c('li',[_vm._v(_vm._s(item.text))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }